/**
 * @file Attendant drop service
 * @author Tzi Yang Lum
 */
import * as tslib_1 from "tslib";
import { DropBase } from './drop-base';
var AttendantDrop = /** @class */ (function (_super) {
    tslib_1.__extends(AttendantDrop, _super);
    /**
     * Creates an instance of AttendantDrop.
     */
    function AttendantDrop(domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) {
        var _this = _super.call(this, 'attendant-drop', 'APP.EXECUTORS.ATTENDANT_DROP_NAME', ['Attendant'], 'Attendant', domainService, overlayService, dropTargetsService, dialogService, translateService, userService, resourceService) || this;
        // The exactPositioning value for the executors
        _this.exactPositioning = true;
        return _this;
    }
    /**
     * The business logic for this executor and is executed after the
     * validation step and before the finish step.
     *
     * @param {ExecutorData} data The executor data
     * @returns {Promise<any>}
     */
    AttendantDrop.prototype.process = function (data) {
        var _this = this;
        return new Promise(function (resolve, reject) {
            _this.explodeExecutorData(data).forEach(function (slice) {
                _this.setAttendant(slice.item, slice.resource);
            });
            _this.saveChanges(reject, resolve);
        });
    };
    /**
     * The logic for the showing the valid drop targets
     * @param {ExecutorData} data
     */
    AttendantDrop.prototype.showDropTargets = function (data) {
        var _this = this;
        // Use the DropTargetService to make the drop targets visible
        this.dropTargetsService.doComplyResourcesDropTargets(data, function () {
            return _this.dropTargetsService.doTimeslotDropTargets(data);
        });
    };
    /**
     * Assign a Resource to an unplanned Attendant of a Service.
     * @protected
     * @param {Entity} item The Attendant.
     * @param {Resource} resource The Resource to assign to an Attendant.
     * @returns {Promise<void>} Promise of execution.
     * @memberOf Drop
     */
    AttendantDrop.prototype.setAttendant = function (item, resource) {
        return new Promise(function (resolve, reject) {
            item['Resource'] = resource;
            resolve();
        });
    };
    return AttendantDrop;
}(DropBase));
export { AttendantDrop };
